import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Chip } from '@material-ui/core'
import dayjs from 'dayjs'
import OperationalTable from '../../../organisms/OperationalTable'
import SydActionMenu from '../../../commonDesign/SydActionMenu'

function ScheduleTable ({ schedules, onRowClick, onEnable, onDisable, onEdit, onDelete }) {
  const columns = useMemo(() => [
    { id: 'name', accessor: 'name', Header: 'Name' },
    { id: 'code', accessor: 'code', Header: 'Code' },
    {
      id: 'expression',
      accessor: 'expression',
      Header: 'Expression',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => <code>{value}</code>
    },
    {
      id: 'target',
      accessor: (row) => row.targetDisplayName || row.targetCode,
      Header: 'Target'
    },
    {
      id: 'enabled',
      accessor: 'enabled',
      Header: 'Enabled',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => value ? 'Yes' : 'No'
    },
    {
      id: 'lastFiredAt',
      accessor: 'lastFiredAt',
      Header: 'Last Fired',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => value ? dayjs(value).format('MMM D, YYYY h:mm A') : '\u2014'
    },
    {
      id: 'lastHandoffStatus',
      accessor: 'lastHandoffStatus',
      Header: 'Status',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => value
        ? <Chip label={value} size='small' color={value === 'success' ? 'primary' : 'secondary'} />
        : '\u2014'
    },
    {
      id: 'actions',
      Header: '',
      disableSortBy: true,
      /* eslint-disable react/prop-types */
      Cell: ({ row }) => {
        const schedule = row.original
        const actions = [
          schedule.enabled
            ? { key: 'disable', label: 'Disable', icon: 'pause', onClick: () => onDisable(schedule) }
            : { key: 'enable', label: 'Enable', icon: 'play_arrow', onClick: () => onEnable(schedule) },
          { key: 'edit', label: 'Edit', icon: 'edit', onClick: () => onEdit(schedule) },
          { key: 'delete', label: 'Delete', icon: 'delete', onClick: () => onDelete(schedule) }
        ]
        return (
          <div onClick={(e) => e.stopPropagation()}>
            <SydActionMenu actions={actions} />
          </div>
        )
      }
      /* eslint-enable react/prop-types */
    }
  ], [onEnable, onDisable, onEdit, onDelete])

  return (
    <OperationalTable
      variant='v2'
      columns={columns}
      data={schedules}
      defaultSort={[{ id: 'name', desc: false }]}
      onRowClick={onRowClick}
    />
  )
}

ScheduleTable.propTypes = {
  schedules: PropTypes.array.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onEnable: PropTypes.func.isRequired,
  onDisable: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
}

export default ScheduleTable
